<template>
    <main id="subPage">
        <!-- 카테고리 -->
        <section id="category">
            <article> 
                <h2>회원가입</h2>
                <ul class="breadCrumb">
                    <li class="home"></li>
                    <li>
                        <p class="pageTxt">회원가입(사업자)</p>
                        <ul class="depth">
                            <li><router-link to="/membershipagreement" title="회원가입(일반)">회원가입(일반)</router-link></li>
                            <li><router-link to="/businessagreement" title="회원가입(사업자)">회원가입(사업자)</router-link></li>
                        </ul> 
                    </li>
                </ul>
            </article>
        </section>

        <!-- 컨텐츠 영역 -->
        <section id="content">
            <div class="inner">
                <!--stepArea-->
                <div class="stepArea type02">
                    <ul>
                        <li><span>1</span><p>이용약관 확인 및 동의</p></li>
                        <li><span>2</span><p>정보입력</p></li>
                        <li class="on"><span>3</span><p>회원가입 신청완료</p></li>
                    </ul>
                </div>
                <!--//stepArea-->

                <!--completeArea-->
                <div class="completeArea">
                    <div class="check">
                        <div class="circle">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34.172" height="24.433" viewBox="0 0 34.172 24.433">
                                <path class="line" id="path" data-name="패스 91977" d="M32.516,6l-19.6,19.6L4,16.693" transform="translate(-1.172 -3.172)"
                                fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
                            </svg>
                        </div>
                    </div>
                    <strong>회원가입 신청이 완료되었습니다.</strong>
                    <p>신청결과는 문자로 안내해 드립니다.</p>
                    <p>문의사항은 공공사업팀(031-635-2070)으로 문의주시기 바랍니다.</p>

                    <!--btnArea-->
                    <div class="btnArea">
                        <button type="button" class="btn blue" @click="$router.push('/main')">메인으로 이동</button>
                    </div>
                    <!--//btnArea-->
                </div>

                
            </div>
        </section>

    </main>
</template>

<script>

export default {

    data(){
        return{
        }
    },

    components: {
    },

    mounted(){

    },

    methods : {

    },

}
</script>
